<template>
  <div v-if="loadingStatus" class="body-max-width">
    <Header menu="disable" back="/home" :title="headerName"></Header>
    <!-- <div class="flex-mid pt-40">
      <div class="fs-18 fc-000000 pt-40">
        <div class="pt-40 center">
          <img
            src="@/assets/image/Well_Line02_.gif"
            alt=""
            class="mx-auto"
            style="
              width: 100%;
              max-width: 19rem;
              height: 100%;
              margin-bottom: 0px;
              object-fit: scale-down;
            "
          />
        </div>
        <div class="center">{{ $t("searching1") }}</div>
        <div class="center">{{ $t("searching2") }}</div>
      </div>
    </div> -->
    <div class="flex-mid">
      <div
        class="fs-18 fc-000000 pt-40"
        style="margin-left: -25px; margin-right: -25px; overflow: hidden"
      >
        <div class="pt-10 center" style="width: 100%; overflow: hidden">
          <img
            src="@/assets/image/Well_Line02_.gif"
            alt="Loading"
            class=""
            style="
              width: 120%;
              margin-left: -20px;
              /* margin-right: -10px; */
              /* max-width: 25rem; */
              /* left:-20px; */
              height: 120%;
              /* margin-bottom: 0px; */
              object-fit: cover;
              overflow: hidden;
              /* object-position: 30% 10%; */
            "
          />
        </div>
        <div class="dialog-water">
          <div class="fs-18 fw-500 center">{{ $t("loading") }}</div>
        </div>
        <!-- <div class="center">{{ $t("loading") }}</div> -->
      </div>
    </div>
  </div>

  <div v-else>
    <div class="mock-footer relative">
      <div class="bottom-screen">
        <div class="footer-menu relative overflow-hidding">
          <div style="max-width: 500px; margin: auto">
            <div style="overflow: hidden">
              <div class="flex-center" style="float: left; display: flex">
                <div>
                  <div class="total-label fs-17 fw-500 fc-52684F mr-10">
                    {{ $t("total") }}
                  </div>
                </div>
                <div>
                  <div
                    class="price-label fs-17 fw-500 ml-auto"
                    style="text-align: right"
                  >
                    {{ numberWithCommas(totalAmount.total) }} {{ $t("baht") }}
                    <!-- {{(totalAmount.total) }} {{ $t("baht") }} -->
                  </div>
                  <div
                    v-if="totalAmount.fullTotal > totalAmount.total"
                    class="price-label right fs-16 fw-500 fc-9A9A9A"
                    style="text-decoration: line-through"
                  >
                    {{ numberWithCommas(totalAmount.fullTotal) }}
                    {{ $t("baht") }}
                    <!-- {{ (totalAmount.fullTotal) }}
                    {{ $t("baht") }} -->
                  </div>
                </div>
              </div>
              <div
                v-if="channel == 'supperapp'"
                style="float: right; display: flex"
              >
                <!-- <div @click="checkOut('home')" class="cart-button">
                  <svg width="100%" height="18" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.31485 2.16648L4.25967 14.8078C4.27382 14.9122 4.30342 15.0116 4.3461 15.1037C4.47456 15.3811 4.72147 15.5925 5.02191 15.6728C5.11369 15.6975 5.20988 15.7098 5.30827 15.7081H16.7502C17.2102 15.7081 17.6157 15.4064 17.7479 14.9658L20.8729 4.54914C20.9675 4.23375 20.9074 3.89219 20.7109 3.62801C20.5143 3.36384 20.2044 3.20815 19.8752 3.20815H4.58295L4.24035 0.981267C4.22752 0.888161 4.20238 0.798981 4.16663 0.715423C4.10174 0.56326 4.00238 0.431455 3.87964 0.328142C3.76576 0.23211 3.631 0.160051 3.48315 0.119742C3.3901 0.0942585 3.29246 0.0814943 3.19255 0.0831509H1.12516C0.549866 0.0831509 0.0834961 0.549521 0.0834961 1.12482C0.0834961 1.70011 0.549866 2.16648 1.12516 2.16648H2.31485ZM6.18551 13.6248L4.90346 5.29148H18.4751L15.9751 13.6248H6.18551Z"
                      fill="#3FBEB6" />
                    <path
                      d="M8.41683 18.8332C8.41683 19.9837 7.48409 20.9165 6.3335 20.9165C5.1829 20.9165 4.25016 19.9837 4.25016 18.8332C4.25016 17.6826 5.1829 16.7498 6.3335 16.7498C7.48409 16.7498 8.41683 17.6826 8.41683 18.8332Z"
                      fill="#3FBEB6" />
                    <path
                      d="M17.7918 18.8332C17.7918 19.9837 16.8591 20.9165 15.7085 20.9165C14.5579 20.9165 13.6252 19.9837 13.6252 18.8332C13.6252 17.6826 14.5579 16.7498 15.7085 16.7498C16.8591 16.7498 17.7918 17.6826 17.7918 18.8332Z"
                      fill="#3FBEB6" />
                  </svg>
                </div>
                <div @click="checkOut('checkout')" class="payment-button right">
                  <p style="margin: auto">{{ $t("pay") }}</p>
                </div> -->
                <div
                  @click="confirmModal"
                  class="payment-button center"
                  id="makeAppointment"
                >
                  <p style="margin: auto">
                    {{ $t("makeAppointment") }}
                  </p>
                </div>
              </div>
              <div v-else style="float: right; display: flex">
                <div @click="reserve" class="payment-button center">
                  <p style="margin: auto">
                    {{ $t("makeAppointment") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="!loadingStatus" id="package_for_you" class="body-max-width">
    <Header menu="disable" back="/home" :title="headerName"></Header>
    <div>
      <div class="body-max-width fs-12">{{ $t("forThai") }}</div>
      <div class="fs-18 fw-500 mt-10">
        {{ $t("choosehospital") }}
      </div>
      <el-select
        v-model="selectHospital"
        class="mt-18 hospital-input"
        id="selectHospital"
        :placeholder="$t('choosehospital')"
        @change="getData()"
      >
        <el-option
          v-for="hospital in hospitals"
          :key="hospital.hospitalId"
          :label="hospital.hospitalName"
          :value="hospital.hospitalId.toString()"
        >
        </el-option>
      </el-select>

      <!-- <div v-if="channel != 'supperapp'"> -->
      <div class="appdatefw-500 mt-10">{{ $t("appdate") }}</div>
      <div>
        <el-date-picker
          v-model="form.bookingDate"
          id="selectAppointmentDate"
          class="normal2 DBAdmanX mt-10"
          :class="`${alertSelectDate ? 'error' : ''}`"
          style="width: 100%"
          type="date"
          :disabled-date="disabledDate"
          :placeholder="'Pick date'"
          show-on="button"
        />
      </div>
      <div v-if="alertSelectDate" style="color: red; font-size: 1.2rem">
        {{ $t("notFillDate") }}
      </div>
      <!-- </div> -->
    </div>
  </div>
  <div v-if="!loadingStatus" style="background-color: #fafafa">
    <div class="body-max-width">
      <div class="package-container">
        <div
          v-if="selectPackageData.length == 0"
          class="package mt-22 fs-16"
          style="text-align: center; padding: 4rem"
        >
          {{ $t("nothavePack") }}
        </div>
        <div v-else>
          <div class="package mt-22">
            <div class="expend-package showing">
              <div
                class="sub-package"
                v-for="val in selectPackageData"
                :key="val.id"
                :style="
                  !Isprerequisite(val) || !val.available
                    ? 'background-color:#F2F2F2'
                    : ''
                "
              >
                <div class="flex">
                  <div class="checkbox">
                    <div @click="toggleSelect(val)" class="checkbox-container">
                      <div v-if="val.select" class="checked"></div>
                    </div>
                  </div>
                  <div class="body">
                    <div
                      class="include-label mb-1 fw-600"
                      style="white-space: pre-wrap"
                    >
                      {{ val.packageName }}
                    </div>
                    <div
                      v-for="descrition in val.itemList"
                      :key="descrition.itemId"
                      class="include-label mb-1"
                      style="white-space: pre-wrap; color: #545454"
                    >
                      • {{ descrition.itemName }}
                    </div>
                    <div v-if="val.selected == -1" style="color: #c31212">
                      <div>{{ $t("alreadyBuy") }}</div>
                    </div>
                    <div
                      v-if="!Isprerequisite(val)"
                      class="prerequisite-notice fs-10"
                    >
                      <div v-if="selectbefore">
                        <p>
                          {{ $t("pleasSelect") }}
                          {{ getName(val) }} {{ $t("pleasSelect2") }}
                        </p>
                      </div>
                    </div>
                    <div
                      v-if="!val.available"
                      class="prerequisite-notice fs-10"
                    >
                      <p>
                        {{ $t("pleaseUnselect") }}
                      </p>
                    </div>
                    <div
                      v-else-if="!IsprerequisitePrice(val)"
                      class="prerequisite-notice fs-10"
                    >
                      <div v-if="selectbefore">
                        <p>
                          {{ $t("pleasSelect") }}
                          {{ getName(val) }} {{ $t("pleasSelect2") }}
                        </p>
                      </div>
                    </div>
                    <div
                      v-if="!val.available"
                      class="prerequisite-notice fs-10"
                    >
                      <p>
                        {{ $t("pleaseUnselect") }}
                      </p>
                    </div>
                  </div>
                  <div class="pricing Avenir fs-14 fw-500">
                    <div
                      v-if="
                        val.netPrice < val.listPrice && IsprerequisitePrice(val)
                      "
                      class="pricing-sale-mobile"
                    >
                      <div class="fc-C31212 ml-auto">
                        {{ numberWithCommasLine(val.netPrice) }}
                      </div>
                      <div class="sale">
                        {{ numberWithCommasLine(val.listPrice) }}
                      </div>
                    </div>
                    <div v-else>{{ numberWithCommasLine(val.listPrice) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="package-container">
        <div v-if="prerequisiteList.length > 0" class="package mt-22">
          <div class="flex-center relative">
            <div class="mr-auto flex-center flex-warp title">
              <div v-if="selectPackageData.isShow">
                {{ $t("prerequisiteCategory") }}
              </div>
              <div v-else>{{ $t("prerequisiteCategoryฺBeforeDiscount") }}</div>
            </div>
            <div
              class="icon-arrow relative flex-mid"
              @click="showPrerequisite = !showPrerequisite"
            >
              <div :class="`arrow-show mt-2 ${showPrerequisite ? 'show' : ''}`">
                <svg
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.66952 0.246055C8.51098 0.0884582 8.29653 0 8.07298 0C7.84944 0 7.63498 0.0884582 7.47644 0.246055L4.43875 3.24144L1.44337 0.246055C1.28483 0.0884582 1.07037 0 0.846829 0C0.623287 0 0.408828 0.0884582 0.250291 0.246055C0.170982 0.324716 0.108033 0.418302 0.0650749 0.521413C0.0221168 0.624525 0 0.735122 0 0.846824C0 0.958527 0.0221168 1.06912 0.0650749 1.17224C0.108033 1.27535 0.170982 1.36893 0.250291 1.44759L3.83798 5.03529C3.91664 5.11459 4.01023 5.17754 4.11334 5.2205C4.21645 5.26346 4.32705 5.28558 4.43875 5.28558C4.55045 5.28558 4.66105 5.26346 4.76416 5.2205C4.86728 5.17754 4.96086 5.11459 5.03952 5.03529L8.66952 1.44759C8.74883 1.36893 8.81178 1.27535 8.85474 1.17224C8.8977 1.06912 8.91981 0.958527 8.91981 0.846824C8.91981 0.735122 8.8977 0.624525 8.85474 0.521413C8.81178 0.418302 8.74883 0.324716 8.66952 0.246055Z"
                    fill="black"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div :class="`expend-package ${showPrerequisite ? 'showing' : ''}`">
            <div
              class="sub-package"
              v-for="val in prerequisiteList"
              :key="val.id"
              :style="
                !Isprerequisite(val) || !val.available
                  ? 'background-color:#F2F2F2'
                  : ''
              "
            >
              <div class="line-package mt-0"></div>
              <div class="flex">
                <div class="checkbox mt-10">
                  <div
                    @click="
                      val.selected != -1 ? (val.select = !val.select) : '',
                        selectPackageDup(val)
                    "
                    class="checkbox-container"
                  >
                    <!-- <div class="checkbox-container" @click="selectPackageDup(val)"> -->
                    <div v-if="val.select" class="checked"></div>
                  </div>
                </div>
                <div class="body mt-3">
                  <div
                    class="include-label mb-1 fw-600"
                    style="white-space: pre-wrap"
                  >
                    {{ val.packageName }}
                  </div>
                  <div
                    v-if="val.itemList.length != 0"
                    @click="val.seeDetail = !val.seeDetail"
                  >
                    <div
                      v-if="!val.seeDetail"
                      class="fs-12"
                      style="text-decoration: underline; color: #2d7617"
                    >
                      {{ $t("seedetail") }}
                    </div>
                    <div
                      v-else
                      class="fs-12"
                      style="text-decoration: underline; color: #2d7617"
                    >
                      {{ $t("hideDetail") }}
                    </div>
                  </div>

                  <div v-if="val.seeDetail">
                    <div
                      v-for="descrition in val.itemList"
                      :key="descrition.itemId"
                      class="include-label mb-1"
                      style="white-space: pre-wrap; color: #545454"
                    >
                      • {{ descrition.itemName }}
                    </div>
                  </div>
                  <div
                    style="
                      white-space: pre-line;
                      color: #c31212;
                      font-size: 1.1rem;
                    "
                  >
                    {{ val.packageDescription }}
                  </div>
                  <div v-if="val.selected == -1" style="color: #c31212">
                    <div>{{ $t("alreadyBuy") }}</div>
                  </div>

                  <div
                    v-if="!Isprerequisite(val)"
                    class="prerequisite-notice fs-10"
                  >
                    <div v-if="selectbefore">
                      <p>
                        {{ $t("pleasSelect") }}
                        {{ getName(val) }} {{ $t("pleasSelect2") }}
                      </p>
                    </div>
                  </div>

                  <div v-if="!val.available" class="prerequisite-notice fs-10">
                    <p>
                      {{ $t("pleaseUnselect") }}
                    </p>
                  </div>

                  <div
                    v-else-if="!IsprerequisitePrice(val)"
                    class="prerequisite-notice fs-10"
                  >
                    <p>
                      {{ $t("pleasOptSelect") }}
                      {{ this.getName(val) }}
                    </p>
                  </div>
                </div>
                <div class="pricing Avenir fs-14 fw-500 mt-10">
                  <div
                    v-if="
                      val.netPrice < val.listPrice && IsprerequisitePrice(val)
                    "
                    class="pricing-sale-mobile"
                  >
                    <div class="fc-C31212 ml-auto">
                      {{ numberWithCommasLine(val.netPrice) }}
                    </div>
                    <div class="sale">
                      {{ numberWithCommasLine(val.listPrice) }}
                    </div>
                  </div>
                  <div v-else>{{ numberWithCommasLine(val.listPrice) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-13 mt-20">
        <div class="flex-center">
          <div @click="recommentFunc()" class="checkbox-container ml-auto">
            <div :class="checkOnRecommend ? 'checked' : ''"></div>
          </div>
          <div @click="recommentFunc()" class="fc-696969 fs-14 fw-500 ml-10">
            {{ $t("recommend") }}
          </div>
          <div @click="selectAllFunc()" class="checkbox-container ml-10">
            <div :class="checkOnSelectAll ? 'checked' : ''"></div>
          </div>
          <div @click="selectAllFunc()" class="fc-696969 fs-14 fw-500 ml-10">
            {{ $t("selectAll") }}
          </div>
        </div>
      </div>

      <div class="package-container">
        <!-- <div
          v-if="packageList.length == 0"
          class="package mt-22 fs-16"
          style="text-align: center; padding: 4rem"
        >
          {{ $t("nothave") }}
        </div> -->
        <div v-if="packageList.length != 0">
          <div v-for="value in packageList" :key="value.id">
            <div v-if="value.package.length > 0" class="package mt-22">
              <div class="flex-center relative">
                <div class="mr-auto flex-center flex-warp title">
                  <div style="color: #020202">
                    {{ value.categoryName }}
                  </div>
                  <div
                    v-if="value.severity"
                    :class="`ml-12 status ${
                      value.severity == 1
                        ? 'low'
                        : value.severity == 2
                        ? 'moderate'
                        : 'high'
                    }`"
                  >
                    {{ value.severityName }}
                  </div>
                </div>
                <div
                  class="icon-arrow relative flex-mid"
                  @click="value.statusShow = !value.statusShow"
                >
                  <div
                    :class="`arrow-show mt-2 ${value.statusShow ? 'show' : ''}`"
                  >
                    <svg
                      width="9"
                      height="6"
                      viewBox="0 0 9 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.66952 0.246055C8.51098 0.0884582 8.29653 0 8.07298 0C7.84944 0 7.63498 0.0884582 7.47644 0.246055L4.43875 3.24144L1.44337 0.246055C1.28483 0.0884582 1.07037 0 0.846829 0C0.623287 0 0.408828 0.0884582 0.250291 0.246055C0.170982 0.324716 0.108033 0.418302 0.0650749 0.521413C0.0221168 0.624525 0 0.735122 0 0.846824C0 0.958527 0.0221168 1.06912 0.0650749 1.17224C0.108033 1.27535 0.170982 1.36893 0.250291 1.44759L3.83798 5.03529C3.91664 5.11459 4.01023 5.17754 4.11334 5.2205C4.21645 5.26346 4.32705 5.28558 4.43875 5.28558C4.55045 5.28558 4.66105 5.26346 4.76416 5.2205C4.86728 5.17754 4.96086 5.11459 5.03952 5.03529L8.66952 1.44759C8.74883 1.36893 8.81178 1.27535 8.85474 1.17224C8.8977 1.06912 8.91981 0.958527 8.91981 0.846824C8.91981 0.735122 8.8977 0.624525 8.85474 0.521413C8.81178 0.418302 8.74883 0.324716 8.66952 0.246055Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div
                :class="`expend-package ${value.statusShow ? 'showing' : ''}`"
              >
                <div
                  class="sub-package"
                  v-for="val in value.package"
                  :key="val.id"
                  :style="
                    !Isprerequisite(val) || val.selected == -1 || !val.available
                      ? 'background-color:#F2F2F2'
                      : ''
                  "
                >
                  <div v-if="value.statusShow" class="line-package mt-0"></div>
                  <div class="flex">
                    <div class="checkbox mt-10">
                      <div
                        @click="toggleSelect(val)"
                        class="checkbox-container"
                      >
                        <!-- <div class="checkbox-contaimer" @click="selectPackageDup(val)"> -->

                        <div v-if="val.select" class="checked"></div>
                      </div>
                    </div>
                    <div class="body mt-3">
                      <div
                        class="include-label mb-1 fw-600"
                        style="white-space: pre-wrap"
                      >
                        {{ val.packageName }}
                      </div>
                      <div
                        v-if="val.itemList.length != 0"
                        @click="val.seeDetail = !val.seeDetail"
                      >
                        <div
                          v-if="!val.seeDetail"
                          class="fs-12"
                          style="text-decoration: underline; color: #2d7617"
                        >
                          {{ $t("seedetail") }}
                        </div>
                        <div
                          v-else
                          class="fs-12"
                          style="text-decoration: underline; color: #2d7617"
                        >
                          {{ $t("hideDetail") }}
                        </div>
                      </div>
                      <div v-if="val.seeDetail">
                        <div
                          v-for="descrition in val.itemList"
                          :key="descrition.itemId"
                          class="include-label mb-1"
                          style="white-space: pre-wrap"
                        >
                          • {{ descrition.itemName }}
                        </div>
                      </div>
                      <div
                        style="
                          white-space: pre-line;
                          color: #c31212;
                          font-size: 1.1rem;
                        "
                      >
                        {{ val.packageDescription }}
                      </div>
                      <div v-if="val.selected == -1" style="color: #c31212">
                        <div>{{ $t("alreadyBuy") }}</div>
                      </div>
                      <div
                        v-if="!Isprerequisite(val)"
                        class="prerequisite-notice fs-10"
                      >
                        <div v-if="selectbefore">
                          <p>
                            {{ $t("pleasSelect") }}
                            {{ getName(val) }} {{ $t("pleasSelect2") }}
                          </p>
                        </div>
                      </div>
                      <div
                        v-if="!val.available"
                        class="prerequisite-notice fs-10"
                      >
                        <p>
                          {{ $t("pleaseUnselect") }}
                        </p>
                      </div>
                      <div
                        v-else-if="!IsprerequisitePrice(val)"
                        class="prerequisite-notice fs-10"
                      >
                        <p>
                          {{ $t("pleasOptSelect") }}
                          {{ this.getName(val) }}
                        </p>
                      </div>
                    </div>
                    <div class="pricing Avenir fs-14 fw-500 mt-10">
                      <div
                        v-if="
                          val.netPrice < val.listPrice &&
                          IsprerequisitePrice(val)
                        "
                        class="pricing-sale-mobile"
                      >
                        <div class="fc-C31212 ml-auto">
                          {{ numberWithCommasLine(val.netPrice) }}
                        </div>
                        <div class="sale">
                          {{ numberWithCommasLine(val.listPrice) }}
                        </div>
                      </div>
                      <div v-else>
                        {{ numberWithCommasLine(val.listPrice) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 15rem">&nbsp;</div>
    </div>

    <div
      class="modal fade"
      id="alertModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="alertModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 30px">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
                style="font-size: 40px; padding-right: 10px"
                >&times;</span
              >
            </button>
            <div style="text-align: center">
              <div style="margin: auto; max-width: 30rem">
                <Vue3Lottie :animationData="alertImg" :speed="1" />
              </div>
              <h1 class="DBAdmanX" style="font-weight: 400; font-size: 2.5rem">
                {{ errmsg }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="confirmModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="alertModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 30px">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
                style="font-size: 40px; padding-right: 10px"
                >&times;</span
              >
            </button>
            <div style="text-align: center">
              <!-- <div style="margin: auto; max-width: 30rem">
                <Vue3Lottie :animationData="alertImg" :speed="1" />
              </div> -->
              <h1 style="font-size: 2rem; font-weight: 400; margin-top: 2rem">
                {{ $t("checkTheDetail") }}
              </h1>
              <div
                style="
                  text-align: left;
                  font-size: 1.8rem;
                  font-weight: 400;
                  margin-top: 2rem;
                  margin-left: 2rem;
                "
              >
                <div>{{ $t("location") }} : {{ selectHospitalName }}</div>
                <div>
                  {{ $t("dateAppointment") }} : {{ selectAppointmentDate }}
                </div>
              </div>
            </div>
            <div class="confirm-button" style="margin-top: 2rem">
              <div class="button-edit" @click="editDetail">
                {{ $t("edit") }}
              </div>
              <div class="button" @click="confirmation">
                {{ $t("confirm") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="loadingModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="loadingModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 30px">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
                style="font-size: 40px; padding-right: 10px"
                >&times;</span
              >
            </button>
            <div style="text-align: center">
              <Vue3Lottie
                :animationData="waitingImg"
                :speed="1"
                style="margin: auto; max-width: 300px"
              />
              <h1 class="DBAdmanX" style="font-size: 2.5rem">
                {{ $t("wating") }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="successModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="successModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="border-radius: 30px">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
                style="font-size: 40px; padding-right: 10px"
                >&times;</span
              >
            </button>
            <div style="margin-top: 10px; text-align: center">
              <img src="@/assets/image/thankyou.gif" style="height: 250px" />
              <h1 class="DBAdmanX" style="margin-top: 2rem; font-size: 2rem">
                {{ $t("thank") }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="errorModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="errorModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" style="border-radius: 30px">
        <div class="modal-body">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="redirect('?mainapp')"
          >
            <span
              aria-hidden="true"
              style="font-size: 40px; padding-right: 10px"
              >&times;</span
            >
          </button>
          <div style="text-align: center">
            <Vue3Lottie :animationData="errorImg" :speed="1" />

            <h3>Something went wrong</h3>
            <p style="font-size: 12px">
              please try again later or contact us +66(0) 2022 2222
            </p>
            <p class="font-DBAdmanX" style="font-size: 2.5rem">
              error : {{ errmsg }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";
import axios from "axios";
import * as config from "@/assets/js/config.js";
import errorImg from "@/assets/image/36572-under-maintenance.json";
import alertImg from "@/assets/image/13539-sign-for-error-or-explanation-alert.json";
import waitingImg from "@/assets/image/87336-hero-animation-for-health-care.json";
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");

export default defineComponent({
  name: "PackageSelect",
  components: {
    Header,
  },
  data() {
    return {
      errorImg,
      channel: "supperapp",
      alertImg,
      waitingImg,
      selectHospital: "1",
      selectHospitalName: "",
      selectAppointmentDate: "",
      headerName: "",
      seeDetail: false,
      packageId: null,
      loadingStatus: true,
      checkOnSelectAll: false,
      checkOnRecommend: false,
      errmsg: null,
      accessToken: null,
      lang: null,
      selectbefore: false,
      list: [],
      packageList: [],
      selectPackageList: [],
      selectPackageData: [],
      showPrerequisite: true,
      prerequisiteList: [],
      hospitals: [],
      confirmselection: false,
      alertSelectDate: false,
      form: {
        bookingDate: "",
      },
      username: "",
      memberId: "",
      disabledDate: (time) => {
        return time.getTime() < Date.now() + 3 * 24 * 60 * 60 * 1000;
      },
    };
  },
  computed: {
    totalAmount: function () {
      const selectedItems = [];
      let total = 0;
      let fullTotal = 0;
      for (let i in this.packageList) {
        for (let item of this.packageList[i].package) {
          if (item.select && !selectedItems.includes(item.packageId)) {
            selectedItems.push(item.packageId); //+ ':1')
          }
        }
      }
      for (let i in this.selectPackageData) {
        console.log("selectPackageData", this.selectPackageData[i]);

        if (
          this.selectPackageData[i].select &&
          !selectedItems.includes(this.selectPackageData[i].packageId)
        ) {
          selectedItems.push(this.selectPackageData[i].packageId); //+ ':1')
        }
      }
      console.log("selectedItems", selectedItems);
      const countPrice = [];
      for (let i in this.packageList) {
        for (let item of this.packageList[i].package) {
          if (item.select && !countPrice.includes(item.packageId)) {
            countPrice.push(item.packageId);
            selectedItems.shift(item.packageId);
            console.log("selectedItems here", selectedItems);
            // if (item.prerequisite.every((ai) => selectedItems.includes(ai))) {
            if (
              item.prerequisite.length == 0 ||
              item.prerequisite.some((ai) => selectedItems.includes(ai))
            ) {
              total += item.select ? item.netPrice : 0;
            } else {
              total += item.select ? item.listPrice : 0;
            }
            fullTotal += item.select ? item.listPrice : 0;
          }
        }
      }

      for (let i in this.selectPackageData) {
        if (
          this.selectPackageData[i].select &&
          !countPrice.includes(this.selectPackageData[i].packageId)
        ) {
          countPrice.push(this.selectPackageData[i]);
          selectedItems.shift(this.selectPackageData[i]);
          console.log("selectedItems here", selectedItems);
          // if (item.prerequisite.every((ai) => selectedItems.includes(ai))) {
          if (
            this.selectPackageData[i].prerequisite.length == 0 ||
            this.selectPackageData[i].prerequisite.some((ai) =>
              selectedItems.includes(ai)
            )
          ) {
            total += this.selectPackageData[i].select
              ? this.selectPackageData[i].netPrice
              : 0;
          } else {
            total += this.selectPackageData[i].select
              ? this.selectPackageData[i].listPrice
              : 0;
          }
          fullTotal += this.selectPackageData[i].select
            ? this.selectPackageData[i].listPrice
            : 0;
        }
      }

      console.log("fullTotal", fullTotal);

      return {
        fullTotal: fullTotal,
        total: total,
      };
    },
    SelectPackage: function () {
      const selectedItems = [];
      const selectedItemsData = [];

      for (let i in this.packageList) {
        for (let item of this.packageList[i].package) {
          if (item.select) {
            // if (!(selectedItems.includes(item.packageId))) {
            selectedItems.push(item.packageId);
            selectedItemsData.push(item);
            // }
          }
        }
      }

      for (let i in this.selectPackageData) {
        if (this.selectPackageData[i].select) {
          if (!selectedItems.includes(this.selectPackageData[i].packageId)) {
            selectedItems.push(this.selectPackageData[i].packageId);
            selectedItemsData.push(this.selectPackageData[i]);
          }
        }
      }
      for (let i in this.prerequisiteList) {
        if (this.prerequisiteList[i].select) {
          if (!selectedItems.includes(this.prerequisiteList[i].packageId)) {
            selectedItems.push(this.prerequisiteList[i].packageId);
            selectedItemsData.push(this.prerequisiteList[i]);
          }
        }
      }

      return selectedItemsData;
    },
  },
  mounted() {
    this.channel = this.$cookies.get("channel");
    this.accessToken = this.$cookies.get("access_token");
    this.lang = this.$cookies.get("lang");
    this.selectHospital = this.$route.query.hospitalId;
    this.packageId = this.$route.query.packageId;
    this.username = this.$cookies.get("username");
    this.memberId = this.$cookies.get("memberId");
    this.getData();
    this.getClickPackage(this.packageId);
  },
  methods: {
    redirect(redirect) {
      window.location.href = redirect;
    },
    numberWithCommasLine(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ".-";
    },
    numberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    IsprerequisitePrice(item) {
      let prerequisite = item.prerequisite;
      // let subSetPackage = item.subSetPackage;
      let check = false;
      this.selectbefore = false;
      const selectedItems = [];
      for (let i in this.selectPackageData) {
        if (this.selectPackageData[i].select) {
          selectedItems.push(this.selectPackageData[i].packageId);
        }
      }
      for (let i in this.prerequisiteList) {
        if (this.prerequisiteList[i].select) {
          selectedItems.push(this.prerequisiteList[i].packageId);
        }
      }
      for (const group of this.packageList) {
        for (const item of group.package) {
          if (item.select) {
            selectedItems.push(item.packageId); //+ ':1')
          }
        }
      }
      // if (prerequisite.every((ai) => selectedItems.includes(ai))) {
      if (
        prerequisite.length == 0 ||
        prerequisite.some((ai) => selectedItems.includes(ai))
      ) {
        // return true;
        check = true;
      } else {
        // item.select = false;
        // return false;
        check = false;
        this.selectbefore = true;
      }

      // if (subSetPackage.lenght == 0) {
      //   check = true;
      //   this.selectbefore = false
      // } else if (subSetPackage.some((ai) => selectedItems.includes(ai))) {
      //   if (item.select) {
      //     check = false;
      //   }
      //   else {
      //     check = true
      //   }
      // }
      // else {
      //   check = true;
      // }

      return check;
    },
    selectPackageDup(val) {
      console.log(val);
      console.log(this.packageList);
      for (let i = 0; i < this.packageList.length; i++) {
        console.log(this.packageList[i]);
        for (let j = 0; j < this.packageList[i].package.length; j++)
          if (this.packageList[i].package[j].packageId == val.packageId)
            this.packageList[i].package[j].select = val.select;
      }
      if (val.packageId == this.packageId) {
        console.log(this.selectPackageList);
        for (let i = 0; i < this.selectPackageList.length; i++) {
          if (val.packageId == this.selectPackageList[i].packageId) {
            this.selectPackageList[i].select = val.select;
            console.log(this.selectPackageList[i]);
          }
        }
        this.selectPackageList;
      }
    },
    toggleSelect(val) {
      if (val.selected == 0 || val.selected == 1) {
        val.select = !val.select;
        this.form.checkOnRecommend = false;
        this.form.checkOnSelectAll = false;
        this.IssubSetPackage(val);
        // this.form.unCheckOnSelectAll = false;
      }
      console.log(val);
      for (let i in this.packageList) {
        for (let j in this.packageList[i].package) {
          // console.log("package",this.list[i].package[j])
          if (this.packageList[i].package[j].packageId == val.packageId) {
            console.log("packageId", this.packageList[i].package[j].packageId);
            this.packageList[i].package[j].select = val.select;
          }
        }
      }
    },
    Isprerequisite(item) {
      let prerequisite = item.prerequisite;
      const selectedItems = [];
      for (const group of this.list) {
        for (const item of group.package) {
          if (item.select) {
            selectedItems.push(item.packageId); //+ ':1')
          }
        }
      }
      // if (prerequisite.every((ai) => selectedItems.includes(ai))) {
      if (
        prerequisite.length == 0 ||
        prerequisite.some((ai) => selectedItems.includes(ai))
      ) {
        return true;
      } else {
        item.select = false;
        return false;
      }
      // let prerequisite = item.prerequisite;
      // // let subSetPackage = item.subSetPackage;
      // let check = false;
      // this.selectbefore = false;
      // const selectedItems = [];
      // for (const group of this.packageList) {
      //   for (const item of group.package) {
      //     if (item.select) {
      //       selectedItems.push(item.packageId); //+ ':1')
      //     }
      //   }
      // }
      // // if (prerequisite.every((ai) => selectedItems.includes(ai))) {
      // if (!item.isShow) {
      //   if (
      //     prerequisite.length == 0 ||
      //     prerequisite.some((ai) => selectedItems.includes(ai))
      //   ) {
      //     // return true;
      //     check = true;
      //   } else {
      //     item.select = false;
      //     check = false;
      //     this.selectbefore = true;
      //     // return false;
      //   }
      // } else {
      //   check = true;
      //   // return true;
      // }
      // return check;
    },
    IssubSetPackage(item) {
      let subsetpackage = item.subSetPackage;
      // console.log("subsetPackage",subsetpackage,item.packageId);
      const selectedItems = [];
      for (const group of this.list) {
        for (const item of group.package) {
          if (item.select) {
            selectedItems.push(item.packageId); //+ ':1')
          }
        }
      }
      console.log("item.select outside", item.select);
      for (let i in subsetpackage) {
        // console.log(subsetpackage[i])
        if (item.select) {
          // console.log("item.select",item.select,subsetpackage[i])
          for (let j in this.list) {
            // console.log(this.list[j].package)
            for (let k in this.list[j].package) {
              // console.log(this.list[j].package[k].packageId)
              if (this.list[j].package[k].packageId == subsetpackage[i]) {
                this.list[j].package[k].select = false;
                this.list[j].package[k].selected = -1;
                this.list[j].package[k].available = false;
                // console.log("in subsetPack", subsetpackage[i], this.list[j].package[k].packageId)
              }
            }
          }
        } else {
          for (let j in this.list) {
            for (let k in this.list[j].package) {
              if (this.list[j].package[k].packageId == subsetpackage[i]) {
                this.list[j].package[k].select = false;
                this.list[j].package[k].selected = 0;
                this.list[j].package[k].available = true;
              }
            }
          }
        }
      }
    },
    getName(val) {
      let ListPackName = [];
      const mapName = new Map();
      const prerequisitePack = val.prerequisite;
      const listCat = this.packageList;

      for (let i = 0; i < listCat.length; i++) {
        const countPack = listCat[i].package.length;
        for (let j = 0; j < countPack; j++) {
          mapName.set(
            listCat[i].package[j].packageId,
            listCat[i].package[j].packageName
          );
        }
      }

      for (let i = 0; i < prerequisitePack.length; i++) {
        ListPackName[i] = mapName.get(prerequisitePack[i]);
      }
      ListPackName = ListPackName.filter((element) => {
        return element;
      });
      return ListPackName.join(this.$t("or"));
    },
    getSubPack(val) {
      let ListPackName = [];
      const mapName = new Map();
      const subSetPackage = val.subSetPackage;
      const listCat = this.list;

      for (let i = 0; i < listCat.length; i++) {
        const countPack = listCat[i].package.length;
        for (let j = 0; j < countPack; j++) {
          mapName.set(
            listCat[i].package[j].packageId,
            listCat[i].package[j].packageName
          );
        }
      }
      for (let i = 0; i < subSetPackage.length; i++) {
        ListPackName[i] = mapName.get(subSetPackage[i]);
      }
      ListPackName = ListPackName.filter((element) => {
        return element;
      });
      return ListPackName.join(this.$t("or"));
    },
    recommentFunc() {
      this.checkOnRecommend = !this.checkOnRecommend;
      this.checkOnSelectAll = false;
      if (this.checkOnRecommend == true) {
        for (let group of this.packageList) {
          for (let pack of group.package) {
            pack.select = pack.selected > 0;
          }
        }
      } else {
        for (let group of this.packageList) {
          for (let pack of group.package) {
            pack.select = false;
          }
        }
      }
    },
    selectAllFunc() {
      this.checkOnSelectAll = !this.checkOnSelectAll;
      this.checkOnRecommend = false;
      if (this.checkOnSelectAll == true) {
        for (let group of this.packageList) {
          for (let pack of group.package) {
            pack.select = true;
          }
        }
      } else {
        for (let group of this.packageList) {
          for (let pack of group.package) {
            pack.select = false;
          }
        }
      }
    },
    getClickPackage(packageId) {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/checkup-package/get/package",
          {
            getCheckupPackageDetailReqBean: {
              packageId: packageId,
              // hospitalId: this.hospitalId,
            },
          },
          {
            headers: {
              Authorization: "Bearer " + this.accessToken,
              "Accept-Language": this.lang,
            },
          }
        )
        .then((res) => {
          let data = res.data;
          this.selectPackageList = data;
          for (let i in this.selectPackageList) {
            this.selectPackageList[i].available = true;
          }
          // this.clickPackages.push(data);
          let hospitals = [];
          for (let i in this.selectPackageList) {
            if (this.selectPackageList[i].selected != -1) {
              this.selectPackageList[i].select = true;
            }
            if (this.selectPackageList[i].hospitalId == this.selectHospital) {
              this.selectPackageData = [this.selectPackageList[i]];
              this.headerName = this.selectPackageList[i].packageName;
              this.prerequisiteList = [];
              for (let j in this.selectPackageList[i].prerequisite) {
                this.getPrerequisite(this.selectPackageList[i].prerequisite[j]);
              }
            }

            // console.log("selectPackageData", this.selectPackageData);
            console.log("prerequisiteList", this.prerequisiteList);
            this.prerequisiteList = this.prerequisiteList.sort(
              (a, b) => a.last_nom - b.last_nom
            );
            hospitals.push({
              hospitalId: this.selectPackageList[i].hospitalId,
              hospitalName: this.selectPackageList[i].hospitalName,
            });
          }
          // this.selectPackageDup(this.selectPackageList)
          this.hospitals = hospitals;
        });
    },
    getPrerequisite(packageId) {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/checkup-package/get/package",
          {
            getCheckupPackageDetailReqBean: {
              packageId: packageId,
              hospitalId: this.selectHospital,
            },
          },
          {
            headers: {
              Authorization: "Bearer " + this.accessToken,
              "Accept-Language": this.lang,
            },
          }
        )
        .then((res) => {
          let data = res.data[0];
          if (data) {
            this.prerequisiteList.push(data);
            // for (let i in res.data.prerequisite) {
            //   this.getPrerequisite(res.data.prerequisite[i]);
            // }
            for (let i in this.prerequisiteList) {
              if (this.prerequisiteList[i].packageId == 1) {
                this.prerequisiteList[i].select = true;
              } else {
                this.prerequisiteList[i].select = false;
              }
            }
          }
        });
    },
    checkOut(redirect) {
      if (!this.form.bookingDate) {
        this.alertSelectDate = true;
        // this.errmsg = this.$t("notFillDate");
        // window.$("#alertModal").modal("show");
        return;
      } else if (!this.selectHospital) {
        this.errmsg = this.$t("notFillDate");
        window.$("#alertModal").modal("show");
        return;
      }
      // this.Loading = true;
      window.$("#loadingModal").modal("show");
      let items = [];
      for (let item of this.SelectPackage) {
        items.push({
          packageId: item.packageId,
          quantity: 1,
          price: this.IsprerequisitePrice(item)
            ? item.netPrice
            : item.listPrice,
        });
      }
      let req = {
        purchaseType: 1,
        purchaseStatus: 2,
        hospitalId: this.selectHospital,
        coin: 0,
        discountCode: null,
        price: this.totalAmount.total,
        primaryAppointmentDate:
          this.form.bookingDate.getFullYear() +
          "-" +
          ("0" + (this.form.bookingDate.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + this.form.bookingDate.getDate()).slice(-2) +
          " 00:00:00",
        secondaryAppointmentDate: null,
        purchaseReqs: items,
      };

      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/purchase/insert",
          req,
          {
            headers: {
              // 'x-api-key': HEALTH_DIARY_API_KEY,
              Authorization: "Bearer " + this.accessToken,
              accept: "application/json; charset=UTF-8",
              "Accept-Language": this.lang,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          let orderNumber = res.data.orderNumber;
          this.Loading = false;

          this.$gtag.config({
            user_id: this.username,
          });
          this.$gtag.event("click_checkoutpackage_select_button", {
            event_category: "PackageSelect_page",
            event_label: "click checkout Package in Package select button",
          });

          if (redirect == "checkout") {
            // window.location = "/checkout?orderId=" + orderNumber;
            window.location = "/home";
          } else {
            window.location = "/home";
          }
        })
        .catch((error) => {
          this.Loading = false;
          if (error.response == null) {
            this.errmsg = error;
          } else if (error.response.status == 403) {
            console.log("token expire");
            this.getNewToken();
          } else {
            if (error.response.data.error) {
              this.errmsg = error.response.data.error;
            } else {
              this.errmsg = error;
            }
          }
          window.setTimeout(function () {
            window.$("#loadingModal").modal("hide");
            window.$("#errorModal").modal("show");
          }, 500);
        });
      // $router.push('/payment')
      // window.location = "/home";
    },
    confirmation() {
      this.confirmselection = true;
      this.reserveWell();
    },
    editDetail() {
      window.$("#confirmModal").modal("hide");
    },
    confirmModal() {
      // console.log("click confirm")
      // window.$("#loadingModal").modal("show");
      if (!this.form.bookingDate) {
        this.alertSelectDate = true;
        // this.errmsg = this.$t("notFillDate");
        // window.$("#alertModal").modal("show");
        return;
      }

      for (let i = 0; i < this.hospitals.length; i++) {
        if (this.hospitals[i].hospitalId == this.selectHospital) {
          this.selectHospitalName = this.hospitals[i].hospitalName;
          this.selectAppointmentDate =
            this.form.bookingDate.getFullYear() +
            "-" +
            ("0" + (this.form.bookingDate.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + this.form.bookingDate.getDate()).slice(-2);
          // console.log(this.hospitals[i].hospitalName)
        }
        // if(i.hospitalId == this.selectHospital){
        //   console.log(i.hospitalName)
        // }
      }
      // this.Loading = true;
      window.$("#confirmModal").modal("show");
    },
    reserveWell() {
      let items = [];
      for (let item of this.SelectPackage) {
        items.push({
          packageId: item.packageId,
          quantity: 1,
          price: this.IsprerequisitePrice(item)
            ? item.netPrice
            : item.listPrice,
        });
      }
      let req = {
        purchaseType: 1,
        purchaseStatus: 9,
        hospitalId: this.selectHospital,
        coin: 0,
        discountCode: null,
        price: this.totalAmount.total,
        primaryAppointmentDate:
          this.form.bookingDate.getFullYear() +
          "-" +
          ("0" + (this.form.bookingDate.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + this.form.bookingDate.getDate()).slice(-2) +
          " 00:00:00",
        purchaseReqs: items,
      };

      if (this.confirmselection) {
        window.$("#confirmModal").modal("hide");

        axios
          .post(
            process.env.VUE_APP_TOTALHEALTHAPI_URL +
              "/total-health-solution/purchase/insert",
            req,
            {
              headers: {
                // 'x-api-key': HEALTH_DIARY_API_KEY,
                Authorization: "Bearer " + this.accessToken,
                accept: "application/json; charset=UTF-8",
                "Accept-Language": this.lang,
                "Content-Type": "application/json",
              },
            }
          )
          .then(() => {
            this.Loading = false;
            window.setTimeout(function () {
              window.$("#successModal").modal("show");
            }, 500);
            window.setTimeout(function () {
              window.location = "/home";
            }, 10000);
          })
          .catch((error) => {
            this.Loading = false;
            if (error.response == null) {
              this.errmsg = error;
            } else if (error.response.status == 403) {
              console.log("token expire");
              this.getNewToken();
            } else {
              if (error.response.data.error) {
                this.errmsg = error.response.data.error;
              } else {
                this.errmsg = error;
              }
            }
            window.setTimeout(function () {
              window.$("#loadingModal").modal("hide");
              window.$("#errorModal").modal("show");
            }, 500);
          });
      }

      // $router.push('/payment')
      // window.location = "/home";
    },
    reserve() {
      if (!this.form.bookingDate) {
        this.alertSelectDate = true;
        // this.errmsg = this.$t("notFillDate");
        // window.$("#alertModal").modal("show");
        return;
      }

      // this.Loading = true;
      window.$("#loadingModal").modal("show");
      let items = [];
      for (let item of this.SelectPackage) {
        items.push({
          packageId: item.packageId,
          quantity: 1,
          price: this.IsprerequisitePrice(item)
            ? item.netPrice
            : item.listPrice,
        });
      }
      let req = {
        purchaseType: 1,
        purchaseStatus: 8,
        hospitalId: this.selectHospital,
        coin: 0,
        discountCode: null,
        price: this.totalAmount.total,
        primaryAppointmentDate:
          this.form.bookingDate.getFullYear() +
          "-" +
          ("0" + (this.form.bookingDate.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + this.form.bookingDate.getDate()).slice(-2) +
          " 00:00:00",
        purchaseReqs: items,
      };

      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/purchase/insert",
          req,
          {
            headers: {
              // 'x-api-key': HEALTH_DIARY_API_KEY,
              Authorization: "Bearer " + this.accessToken,
              accept: "application/json; charset=UTF-8",
              "Accept-Language": this.lang,
              "Content-Type": "application/json",
            },
          }
        )
        .then(() => {
          this.Loading = false;
          window.setTimeout(function () {
            window.$("#loadingModal").modal("hide");
            window.$("#successModal").modal("show");
          }, 500);
          window.setTimeout(function () {
            window.location = "/home";
          }, 10000);
        })
        .catch((error) => {
          this.Loading = false;
          if (error.response == null) {
            this.errmsg = error;
          } else if (error.response.status == 403) {
            console.log("token expire");
            this.getNewToken();
          } else {
            if (error.response.data.error) {
              this.errmsg = error.response.data.error;
            } else {
              this.errmsg = error;
            }
          }
          window.setTimeout(function () {
            window.$("#loadingModal").modal("hide");
            window.$("#errorModal").modal("show");
          }, 500);
        });
      // $router.push('/payment')
      // window.location = "/home";
    },
    getData() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/customer/get",
          {
            hospitalId: this.selectHospital,
          },
          {
            headers: {
              Authorization: "Bearer " + this.accessToken,
              "Accept-Language": this.lang,
            },
          }
        )
        .then((res) => {
          // console.log(this.hospitals.hospitalId == this.selectHospital)
          // customer
          const customer = res.data.customer;
          // riskScore
          const riskScore = res.data.riskAssessment.risks;
          // Riskrecommendationpack
          const healthPackage = [];

          // healthPackage.push({
          //   categoryName: this.$t("prerequisiteCategory"),
          //   severityName: null,
          //   severity: null,
          //   maxSeverity: null,
          //   riskId: null,
          //   statusShow: true,
          //   package: [],
          // });
          for (let i = 0; i < riskScore.length; i++) {
            const recommended = riskScore[i]["recommendationPackage"];
            if (recommended != null && recommended.length > 0) {
              for (let j = 0; j < recommended.length; j++) {
                riskScore[i]["recommendationPackage"][j]["select"] = false;
              }
              healthPackage.push({
                categoryName: riskScore[i].riskName,
                severityName: riskScore[i].severityName,
                severity: riskScore[i].severity,
                maxSeverity: riskScore[i].maxSeverityLevel,
                riskId: riskScore[i].riskId,
                statusShow: true,
                seeDetail: false,
                package: riskScore[i]["recommendationPackage"],
              });
            }
          }
          this.list = healthPackage;
          for (let item of res.data.recommendationPackages) {
            item.select = false;
          }
          const data = this.groupBy(
            res.data.recommendationPackages,
            "categoryName"
          );

          for (const property in data) {
            this.list.push({
              categoryName: property,
              severityName: null,
              severity: null,
              riskId: null,
              maxSeverity: null,
              statusShow: true,
              seeDetail: false,
              package: data[property],
            });
          }

          for (let x in this.list) {
            for (let z in this.list[x].package) {
              // console.log(this.list[x].package[z])
              this.list[x].package[z].available = true;
            }
          }
          // for(let i in this.list){
          //   for(let j in this.list[i].package){
          //     // console.log("print in list",this.list[i].package[j].packageId,this.packageId)
          //     if(this.list[i].package[j].packageId == this.packageId){
          //       // console.log("print in list",this.list[i].package[j].packageId,this.packageId)
          //       this.list[i].package[j].select = true;
          //       this.list[i].package[j].selected = 1;
          //       this.list[i].package[j].available = true;
          //     }
          //   }
          // }

          // for (let i in this.list) {
          //   // console.log("list2 here",this.list2[i].package)
          //   for (let j in this.list[i].package) {
          //     // console.log("list2 here",this.list2[i].package[j])
          //     if (this.list[i].package[j].packageId == this.packageId) {
          //       console.log("list2 package",this.list2[i].package[j])
          //       this.selectPackageData = [this.list[i].package[j]];
          //       this.list[i].package[j].select = true;
          //       this.selectHospitalName = this.list[i].package[j].hospitalName;
          //     }
          //   }
          // }

          console.log("selectPackageData", this.selectPackageData);
          this.packageList = this.list;
          // console.log(this.packageList);
          for (let i = 0; i < this.packageList.length; i++) {
            for (let j = 0; j < this.packageList[i].package.length; j++)
              // for(let j=0;j<this.packageList[i].package;j++){
              if (this.packageList[i].package[j].packageId == this.packageId) {
                this.packageList[i].package[j].select = true;
              }
          }
          for (let i in this.packageList) {
            for (let j in this.packageList[i].package) {
              if (this.packageList[i].package[j].subSetPackage.length != 0) {
                // console.log("package detail",this.list[i].package[j].subSetPackage)
                for (let x in this.packageList) {
                  for (let z in this.packageList[x].package) {
                    if (
                      this.packageList[i].package[j].subSetPackage.includes(
                        this.packageList[x].package[z].packageId
                      )
                    ) {
                      console.log("package detail", this.list[x].package[z]);
                      if (this.packageList[i].package[j].select) {
                        this.packageList[x].package[z].selected = -1;
                        this.packageList[x].package[z].select = false;
                        this.packageList[x].package[z].available = false;
                      }
                      // this.list[x].package[z].available = false;
                    }
                  }
                }
              }
            }
          }

          setTimeout(() => {
            this.loadingStatus = false;
          }, 3000);
        })
        .catch((error) => {
          if (error.response == null) {
            this.errmsg = error;
          } else if (error.response.status == 403) {
            console.log("token expire");
            this.getNewToken();
            // RefreshToken
          } else {
            if (error.response.data.message) {
              this.errmsg = error.response.data.message;
            } else {
              this.errmsg = error;
            }
          }
          // window.setTimeout(function () {
          //   window.$("#loadingModal").modal("hide");
          window.$("#errorModal").modal("show");
          // }, 500);
        });
    },
    // submit() {
    //   console.log(this.SelectPackage)
    //   this.$router.push('/payment')
    // },
    getNewToken() {
      if (this.channel == "plusV5") {
        let plusToken = this.$cookies.get("plus_access_token");
        this.getPlusDataV5(plusToken);
      } else {
        try {
          var refreshToken = this.$cookies.get("refresh_token");
          var token = new AmazonCognitoIdentity.CognitoRefreshToken({
            RefreshToken: refreshToken,
          });

          this.$store.state.userPool =
            new AmazonCognitoIdentity.CognitoUserPool(config.poolData);
          // const cognitoUser = this.$store.state.userPool.getCurrentUser();

          const userData = {
            Username: this.$cookies.get("username"),
            Pool: this.$store.state.userPool,
          };

          const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

          cognitoUser.refreshSession(token, (err, session) => {
            if (err) {
              console.log(err);
              this.loadingStatus = false;
              this.error = err;
              window.$("#errorModal").modal("show");
            } else {
              this.accessToken = session.getIdToken().getJwtToken();
              this.$cookies.set("access_token", this.accessToken);
              this.$cookies.set(
                "refresh_token",
                session.getRefreshToken().getToken()
              );
              window.location.reload();
            }
          });
        } catch {
          this.errmsg = "cannot get NewToken";
          window.$("#errorModal").modal("show");
        }
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.expend-package {
  border-radius: 0.4rem;
  min-height: 0rem;
  max-height: 0rem;
  transform-origin: top center;
  transform: rotate(0.1deg);
  transition: all 0.3s;
  overflow: hidden;
}

.showing {
  transition: all 0.6s;
  // min-height: 10rem;
  max-height: 100rem;
}

.total-label {
  font-size: 1.5rem;

  @media only screen and (max-width: 600px) {
  }
}

.price-label {
  font-size: 1.3rem;
}

.cart-button {
  display: flex;
  background-color: white;
  width: 4rem;
  height: 4rem;
  border-radius: 2rem;
  align-items: center;
  text-align: center;
  margin: 0px;
  padding: 0px;

  @media only screen and (max-width: 600px) {
    font-size: 1rem;
    // margin-left: 1.5rem;
    width: 4rem;
    height: 4rem;
  }

  @media only screen and (max-width: 400px) {
    font-size: 1rem;
    // margin-left: 1rem;
    width: 4rem;
    height: 4rem;
  }
}

.confirm-button {
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 1rem;
  margin: auto;
  margin-top: 2rem;
  padding-left: 10%;
  padding-right: 10%;

  .button {
    width: 11rem;
    height: 5rem;
    border-radius: 11rem;
    background-color: #d1d1ac;
    font-weight: 400;
    font-size: 1.6rem;
    text-align: center;
    line-height: 5rem;
    box-shadow: 3px 4px 7px rgba(165, 165, 165, 0.25);
  }

  .button-edit {
    width: 11rem;
    height: 5rem;
    border-radius: 11rem;
    background-color: #f5f5f0;
    font-weight: 400;
    font-size: 1.6rem;
    text-align: center;
    line-height: 5rem;
    box-shadow: 3px 4px 7px rgba(165, 165, 165, 0.25);
  }
}

.payment-button {
  cursor: pointer;
  display: flex;
  background-color: white;
  font-size: 1.2rem;
  font-weight: 500;
  width: 10rem;
  height: 4rem;
  border-radius: 2rem;
  align-items: center;
  margin-left: 1rem;
  right: 0;
  margin-right: 0rem;

  @media only screen and (max-width: 600px) {
    font-size: 1.2rem;
    margin-left: 1rem;
    width: 10rem;
    border-radius: 1.8rem;
  }

  @media only screen and (max-width: 400px) {
    height: 4rem;
    width: 9rem;
    font-size: 1.2rem;
    margin-left: 1rem;
  }
}

.package-container {
  margin-top: 1.6rem;
  border-radius: 4rem;

  .package {
    background-color: #fff;
    padding: 1.5rem 2rem;
    border-radius: 3rem;
    box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);

    .title {
      color: #020202;
      font-size: 1.4rem;
      font-weight: 500;
    }

    .status {
      padding: 2px 12px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      background: gray;
      text-transform: capitalize;
    }

    .status.high {
      background: #e45757;
    }

    .status.moderate {
      background: #e7c74e;
    }

    .status.low {
      background: #6db557;
    }

    .price {
      color: #000;
      font-size: 2rem;
    }

    .price-changed {
      .old-price {
        color: #b9b9b9;
        font-weight: 500;
        font-size: 2rem;
        text-decoration: line-through;
      }

      .price {
        color: #c31212;
        text-decoration: none;
        font-size: 2rem;
      }
    }

    .icon-arrow {
      margin-left: 7rem;
      margin-bottom: 1rem;
      cursor: pointer;
      width: 3.3rem;
      height: 3.3rem;
      border-radius: 3.3rem;
      background-color: #f3f3e7;
      filter: drop-shadow(3px 4px 4px rgba(148, 148, 148, 0.25));

      .arrow-show {
        position: absolute;
        transform: rotate(180deg);
        transition: 0.3s;
      }

      .arrow-show.show {
        position: absolute;
        transform: rotate(0deg);
      }
    }

    .line-package {
      width: 100%;
      height: 0.1rem;
      background: #cfcfcf;
    }

    .sub-package {
      padding-bottom: 0.3rem;

      .checkbox {
        width: 5rem;
      }

      .body {
        width: calc(100%);
      }

      .pricing {
        // width: 5rem;
        margin-left: 2px;
        text-align: right;

        .sale {
          color: #b9b9b9;
          font-size: 1.1rem;
          text-decoration: line-through;
        }
      }

      @media only screen and (min-width: 600px) {
        .body {
          width: calc(100%);
        }

        .pricing {
          .sale {
            margin-left: 1rem;
          }
        }
      }

      .include-label {
        color: #545454;
        font-size: 1.2rem;
      }

      .prerequisite-notice {
        color: #e78181;
        // font-size: 1.3rem;
      }
    }
  }

  @media only screen and (max-width: 900px) {
    .package {
      padding: 1.5rem 2rem;

      .icon-arrow {
        margin-left: 4rem;
      }
    }
  }

  @media only screen and (max-width: 500px) {
    .package {
      padding: 1.5rem 2rem;

      .icon-arrow {
        margin-left: 2rem;
      }
    }
  }
}

.mock-footer {
  width: 100%;
}

.bottom-screen {
  position: fixed;
  width: 100%;
  // max-width: calc(800px + 3rem);
  bottom: 0;
  z-index: 1;
}

.footer-menu {
  // height: 14rem;
  padding: 1.6rem 2rem;
  // max-width: calc(100% - 3rem);
  bottom: 0;
  background-color: #d5e3d5;
  border-radius: 1.5rem 1.5rem 0 0;
}
</style>

<style lang="scss">
#package_for_you {
  .appdate {
    margin: auto;
    margin-top: 1rem;
    font-size: 1.7rem;
  }

  .hospital-input {
    width: 100%;
    // height: 0rem;
    border-radius: 1.5rem;

    .el-input__inner {
      font-size: 1.3rem;
      height: 3rem;
      border-radius: 1.5rem;
      border: 0;
      outline: 0;
      box-shadow: none;
      border: 1px solid #fff;
      background-color: #fff;
      transition: 0.3s;
      box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
        5px 5px 10px rgba(163, 162, 162, 0.25);

      &:focus {
        border: 1px solid #206b5e;
        box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
          5px 5px 10px rgba(163, 162, 162, 0.25);
      }
    }
  }
}
</style>
